import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonim, obj = giriş yapılmış
  const [org, setOrg] = useState(null);

  const loadOrg = useCallback(async () => {
    try {
      const { data } = await api.get("/organization/public");
      setOrg(data);
    } catch {
      setOrg(null);
    }
  }, []);

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem("tmgd_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("tmgd_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadOrg();
    refreshUser();
  }, [loadOrg, refreshUser]);

  const login = (token, userObj) => {
    localStorage.setItem("tmgd_token", token);
    setUser(userObj);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("tmgd_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, org, setOrg, loadOrg, refreshUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
